



























import { Component, Vue } from 'vue-property-decorator'
import store from '@/store'
import TabPanel from '@/components/TabPanel.vue'
import { TabRoute } from '@/types/frontend'
import { Button } from '@alpha/ink'
import PageHeader from '@/components/PageHeader.vue'
import { WorkspaceWithTestsQuery } from '@/api/graphql-sdk.generated'

@Component({
  components: {
    TabPanel,
    Button,
    PageHeader
  },
  name: 'workspace'
})
export default class WorkspaceView extends Vue {
  error: string | null = null

  get subroutes (): TabRoute<WorkspaceView>[] {
    const names: Array<keyof WorkspaceView> = ['projects', 'tests', 'queue']
    return names.map((name) => {
      const route: TabRoute<WorkspaceView> = { name, attribute: name }
      const attribute = this[name]
      if (attribute && attribute.length && name !== 'queue') {
        route.info = `(${attribute.length})`
      }
      return route
    })
  }

  get projects () {
    return store.getters.workspace.projects
  }

  get tests () {
    return store.getters.workspace.tests
  }

  get queue () {
    return store.getters.workspace.queue
  }

  get reports () {
    return store.getters.workspace.reports
  }

  get workspace (): NonNullable<WorkspaceWithTestsQuery['workspace']> {
    return store.state.workspace.workspaceWithTests
  }
}
